<!-- Intro dialog shown before a tour begins ("what this covers" + Begin). The
     per-step coachmarks (spotlight + popover) and the teaching-nav centered
     popover are rendered by driver.js (WalkthroughDriverService), not here. -->
@if (show() && walkthrough() && !step()) {
  <kendo-dialog [title]="walkthrough()!.title" (close)="end()">
    <div [innerHTML]="walkthrough()!.html"></div>
    <div class="d-flex">
      @if (walkthroughFeature().editAll) {
        <button kendoButton class="me-auto" (click)="edit()">
          Edit Walkthrough
        </button>
      }
      @if (walkthroughFeature().readAll) {
        <button kendoButton class="ms-2" [primary]="true" (click)="start()">
          Begin Walkthrough
        </button>
      }
    </div>
  </kendo-dialog>
}
<!-- Incomplete-tour notice: shown when a tour can't run to completion (no steps,
     or too many consecutive unreachable steps). An explicit, dismissible message
     instead of a silent dead-march that reads as a frozen page. -->
@if (incompleteNotice()) {
  <kendo-dialog title="Walkthrough" (close)="dismissNotice()">
    <div>{{ incompleteNotice() }}</div>
    <div class="d-flex mt-2">
      <button
        kendoButton
        class="ms-auto"
        [primary]="true"
        (click)="dismissNotice()"
      >
        OK
      </button>
    </div>
  </kendo-dialog>
}
<!-- Narration audio controls: mute toggle + replay, shown only during an active tour
     step. driver.js owns the popover, so these live here as a fixed control above its
     overlay (see .ups-walkthrough-audio-controls in driver-theme.scss). -->
@if (show() && step()) {
  <div class="ups-walkthrough-audio-controls">
    <button
      type="button"
      class="ups-walkthrough-audio-btn"
      [attr.aria-label]="
        audioService.muted() ? 'Unmute narration' : 'Mute narration'
      "
      [attr.title]="
        audioService.muted() ? 'Unmute narration' : 'Mute narration'
      "
      (click)="audioService.toggleMute()"
    >
      {{ audioService.muted() ? '🔇' : '🔊' }}
    </button>
    <button
      type="button"
      class="ups-walkthrough-audio-btn"
      aria-label="Replay narration"
      title="Replay narration"
      (click)="audioService.replay()"
    >
      🔁
    </button>
  </div>
}

<!-- The wren stays mounted as the Ask Ryn launcher + standalone "fly to element"
     wayfinding. It no longer flies step-to-step during a tour (driver.js owns the
     tour spotlight/popover now), so it receives no flight input. -->
<ups-walkthrough-wren />
